export default __webpack_public_path__ + "static/media/solutionInstallaton.2bc9a762.jpg";